import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { Notification } from '../../components';
import { SnackbarPosition } from '../../enums';
import { useSnackbarContext } from './SnackbarContextProvider';
import styles from './NotificationSnackbar.module.scss';
const NotificationSnackbar = ({ a11yCloseButtonText, children, className, position = SnackbarPosition.Top, }) => {
    const { a11yText, isOpen, message, onClose, variant } = useSnackbarContext();
    return (_jsx(_Fragment, { children: isOpen ? (_jsx("div", { className: classNames(styles.snackBarContainer, 'w-100 overflow-hidden', {
                'fixed-top': position === SnackbarPosition.Top,
                'fixed-bottom': position === SnackbarPosition.Bottom,
            }, className), children: children || (_jsx(Notification, { message: message, a11yLabel: a11yText, onRequestClose: onClose, variant: variant, a11yCloseButtonText: a11yCloseButtonText })) })) : null }));
};
export { NotificationSnackbar };
